<div>
  <Navbar />
  <Sidebar />

  <div class="page-wrapper">

    <div class="hero-section w-100  ">
      <div class="border border-secondary rounded-4 p-2">
        <!-- Header -->
        <div class="mb-4">
          <h2 class="gradient-text fw-bold">User Management</h2>
          <p class="text-muted">Manage user accounts and system access.</p>
        </div>
          <div class="row text-center mb-3">
            <div class="col-md-4 mb-3">
              <div class="card rounded-4 shadow-sm user-card" :class="{ 'active-filter': filterType === 'all' }" @click="filterType = 'all'">
                <div class="card-body">
                  <p class="card-text display-5">{{ users.length }}</p>
                  <h5 class="card-title">Total Users</h5>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="card rounded-4 shadow-sm user-card" :class="{ 'active-filter': filterType === 'active' }" @click="filterType = 'active'">
                <div class="card-body">
                  <p class="card-text display-5">{{ active_users_count }}</p>
                  <h5 class="card-title">Active Users</h5>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="card rounded-4 shadow-sm user-card" :class="{ 'active-filter': filterType === 'inactive' }" @click="filterType = 'inactive'">
                <div class="card-body">
                  <p class="card-text display-5">{{ inactive_users_count }}</p>
                  <h5 class="card-title">Inactive Users</h5>
                </div>
              </div>
            </div>
          </div>


          <div class="d-flex mb-2">
            <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center"
              data-bs-toggle="modal" data-bs-target="#addUserModal">
              <i class="fas fa-plus plus-icon me-1"></i> Add User
            </button>
            <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
              id="fabMain" @click="toggle_fab" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                aria-hidden="true"></span>
              {{ loading ? 'Migrating...' : 'Migrate Users' }}
            </button>
            <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2" @click="$router.back()">Back</button>
            <div class="fab-container">
              <div class="fab-options position-absolute" :class="{ show: fab_open }" id="fabOptions">
                <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center d-none"
                  title="Proba" @click="migrate_users('proba')">
                  <img :src="require('@/assets/platforms_icons/proba.png')" alt="Proba" class="fab-icon-small" />
                </a>
                <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center d-none"
                  title="Orcaa" @click="migrate_users('orcaa')">
                  <img :src="require('@/assets/platforms_icons/orcaa.png')" alt="Orcaa" class="fab-icon-small" />
                </a>
                <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center d-none"
                  title="X-Verdict" @click="migrate_users('x-verdict')">
                  <img :src="require('@/assets/platforms_icons/xverdict.png')" alt="X-Verdict"
                    class="fab-icon-small" />
                </a>
                <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
                  title="Engagenet" @click="migrate_users('engagenet')">
                  <img :src="require('@/assets/platforms_icons/engagenet.png')" alt="Engagenet"
                    class="fab-icon-small" />
                </a>
                <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center d-none"
                  title="Complyon" @click="migrate_users('complyon')">
                  <img :src="require('@/assets/platforms_icons/complyon.png')" alt="Complyon" class="fab-icon-wide" />
                </a>
                <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center d-none"
                  title="Proba Workflows" @click="migrate_users('proba_workflows')">
                  <img :src="require('@/assets/platforms_icons/proba_two.png')" alt="Proba Workflows"
                    class="fab-icon-small" />
                </a>
              </div>
            </div>
          </div>

          <div class="card table-card">
            <div class="card-body">
              <div class="table-responsive content-table">
                <table id="content_table" class="table text-xs table-striped" data-sort="true">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Last login</th>
                      <th>Client Type</th>
                      <th>Role</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody class="text-start text-xs">
                    <tr v-for="(user, index) in filtered_users" :key="user.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ user.first_name }}</td>
                      <td>{{ user.last_name }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{user.last_login}}</td>
                      <td>{{ user.client_type }}</td>
                      <td>{{ user.role }}</td>
                      <td>
                        <div class="d-flex gap-2">
                          <button class="btn btn-sm upload-button text-nowrap d-none" @click="open_edit_modal(user)" data-bs-toggle="modal" data-bs-target="#editUserModal">
                            Edit
                          </button>
                          <button
                            class="btn btn-sm upload-button text-nowrap"
                            :disabled="is_user_deleting(user.id)"
                            @click="delete_user(user)"
                          >
                            <span
                              v-if="is_user_deleting(user.id)"
                              class="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {{ is_user_deleting(user.id) ? 'Deleting...' : 'Delete' }}
                          </button>
                          <!-- NEW PERMISSIONS BUTTON -->
                          <button class="btn btn-sm upload-button text-nowrap"
                                  @click="navigate_to_permissions(user)">
                            Manage
                          </button>
                         <button
                            v-if="user.is_active"
                            class="btn btn-sm btn-success text-nowrap action-btn-toggle"
                            :disabled="is_user_syncing(user.id)"
                            @click="deactivate_user(user)"
                          >
                            <span
                              v-if="is_user_syncing(user.id)"
                              class="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {{ is_user_syncing(user.id) ? 'Deactivating...' : 'Deactivate' }}
                          </button>
                          <button
                            v-else
                            class="btn btn-sm btn-danger text-nowrap action-btn-toggle"
                            :disabled="is_user_syncing(user.id)"
                            @click="activate_user(user)"
                          >
                            <span
                              v-if="is_user_syncing(user.id)"
                              class="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {{ is_user_syncing(user.id) ? 'Activating...' : 'Activate' }}
                          </button>
                        </div>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Add User Modal -->
          <div class="modal fade" id="addUserModal" tabindex="-1" aria-labelledby="addUserModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title gradient-text" id="addUserModalLabel">Add New User</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                  <form @submit.prevent="add_user">
                    <div class="mb-3 text-start">
                      <label for="first_name" class="ms-2">First Name</label>
                      <input v-model="new_user.first_name" type="text" class="form-control" id="first_name" required>
                    </div>
                    <div class="mb-3 text-start">
                      <label for="last_name" class="ms-2">Last Name</label>
                      <input v-model="new_user.last_name" type="text" class="form-control" id="last_name" required>
                    </div>
                    <div class="mb-3 text-start">
                      <label for="email" class="ms-2">Email</label>
                      <input v-model="new_user.email" type="email" class="form-control" id="email" required>
                    </div>
                    <div class="mb-3">
                      <select v-model="new_user.role_id" class="form-control" id="role_id" required>
                        <option value="" class="ms-2" disabled>Select Role</option>
                        <option v-for="role in roles" :key="role.id" :value="role.id">
                          {{ role.name }}
                        </option>
                      </select>
                    </div>

                    <div class="modal-footer">
                      <button type="submit" class="btn upload-button text-white" :disabled="user_loading">
                        <span v-if="user_loading" class="spinner-border spinner-border-sm me-2" role="status"
                          aria-hidden="true"></span>
                        {{ user_loading ? 'Adding...' : 'Add User' }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit User Modal -->
          <div class="modal fade" id="editUserModal" tabindex="-1" aria-labelledby="editUserModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title gradient-text" id="editUserModalLabel">Edit User</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <form @submit.prevent="update_user">
                    <div class="mb-3 text-start">
                      <label for="edit_first_name" class="ms-2">First Name</label>
                      <input v-model="edit_user.first_name" type="text" class="form-control" id="edit_first_name" required>
                    </div>
                    <div class="mb-3 text-start">
                      <label for="edit_last_name" class="ms-2">Last Name</label>
                      <input v-model="edit_user.last_name" type="text" class="form-control" id="edit_last_name" required>
                    </div>
                    <div class="mb-3 text-start">
                      <label for="edit_email" class="ms-2">Email</label>
                      <input v-model="edit_user.email" type="email" class="form-control" id="edit_email" required>
                    </div>

                    <div class="mb-3 text-start">
                      <label for="edit_role_id" class="ms-2">Role</label>
                      <select v-model="edit_user.role_id" class="form-control" id="edit_role_id" required>
                        <option value="" class="ms-2" disabled>Select Role</option>
                        <option v-for="role in roles" :key="role.id" :value="role.id">
                          {{ role.name }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-3 text-start d-none">
                      <label for="edit_client_type_id" class="ms-2">Client Type</label>
                      <select v-model="edit_user.client_type_id" class="form-control" id="edit_client_type_id">
                        <option :value="null" disabled>Select Client Type</option>
                        <option v-for="ct in client_types" :key="ct.id" :value="ct.id">
                          {{ ct.name }}
                        </option>
                      </select>
                    </div>

                    <div class="modal-footer">
                      <button type="submit" class="btn upload-button text-white" :disabled="user_loading">
                        <span v-if="user_loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {{ user_loading ? 'Updating...' : 'Update User' }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
